var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-3", attrs: { role: "main", id: "instructions" } },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("PaymentRequestER.Title")))]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-5" }, [
        _c("p", [
          _vm._v(_vm._s(_vm.$t("PaymentRequestER.GrantedAmountInstructions")))
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("PaymentRequestER.FormTypeInstructions")))
        ]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Section")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(_vm._s(_vm.$t("PaymentRequestER.PaymentRequest")))
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("b", [
              _vm._v(_vm._s(_vm.$t("PaymentRequestER.IsPaymentRequest")))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(_vm._s(_vm.$t("PaymentRequestER.RequestedAmount")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-0" }, [
              _vm._v(
                _vm._s(_vm.$t("PaymentRequestER.RequestedAmountInstructions"))
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Section")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(_vm._s(_vm.$t("PaymentRequestER.ExpenseReport.Title")))
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm.$t("PaymentRequestER.ExpenseReport.AccountingPeriod")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "PaymentRequestER.ExpenseReport.PreviouslyReportedExpenses"
                  )
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm.$t("PaymentRequestER.ExpenseReport.AidTargetOtherProfit")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm.$t("PaymentRequestER.ExpenseReport.AidTargetExpenses")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm.$t("PaymentRequestER.ExpenseReport.TotalExpensesToReport")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [
              _vm._v(
                _vm._s(_vm.$t("PaymentRequestER.ExpenseReport.Attachments"))
              )
            ]),
            _vm._v(" "),
            _vm.isB
              ? _c("div", {
                  staticClass: "mb-0",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "PaymentRequestER.ExpenseReport.AttachmentsB_InstructionsHtml"
                      )
                    )
                  }
                })
              : _c("div", { staticClass: "mb-0" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "PaymentRequestER.ExpenseReport.Attachments_Instructions"
                      )
                    )
                  )
                ])
          ])
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(_vm.$t("PaymentRequestER.ExpenseReport.Title_Instructions"))
          )
        ]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(_vm._s(_vm.$t("PaymentRequestER.AdditionalInformation")))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }